module.exports = __webpack_public_path__ + "static/img/61.044f992b.png";